export * from '../fornecedor/list/fornecedorList.component';
export * from '../fornecedor/create/fornecedorCreate.component';
export * from '../fornecedor/edit/fornecedorEdit.component';
export * from '../fornecedor/detail/fornecedorDetail.component';
export * from '../fornecedor/search/fornecedorSearch.component';